import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex w-full items-center justify-between sm:justify-end my-6"
}
const _hoisted_2 = { class: "flex items-center relative mr-4" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "p-2 rounded-full hover:bg-cebai-grey-lightest" }
const _hoisted_5 = {
  key: 1,
  class: "my-11"
}
const _hoisted_6 = { class: "flex justify-center" }
const _hoisted_7 = { class: "w-8" }
const _hoisted_8 = {
  key: 0,
  class: "flex flex-wrap items-stretch justify-start -m-3"
}
const _hoisted_9 = {
  key: 1,
  class: "my-6 px-5 py-6 text-base text-cebai-base-dark text-center"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "No challenges found", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 2,
  class: "my-6 px-5 py-6 text-base text-cebai-base-dark text-center"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "No resolved challenges", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "No saved challenges – please start a new one!", -1)
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchIcon = _resolveComponent("SearchIcon")!
  const _component_CloseIcon = _resolveComponent("CloseIcon")!
  const _component_ChallengesListDropdownFilter = _resolveComponent("ChallengesListDropdownFilter")!
  const _component_LoadingIcon = _resolveComponent("LoadingIcon")!
  const _component_ChallegesListItem = _resolveComponent("ChallegesListItem")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.hasFilter)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_SearchIcon, {
              class: _normalizeClass(["flex-none fill-current mr-2", 
          !_ctx.hasChallenges && !_ctx.hasSearchText
            ? 'text-cebai-grey-dark'
            : 'text-cebai-base-dark'
        ])
            }, null, 8, ["class"]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
              type: "text",
              placeholder: "Search challenges",
              class: _normalizeClass(["pr-8 border-b bg-transparent placeholder-cebai-base-dark focus:placeholder-cebai-grey-dark disabled:placeholder-cebai-grey-dark outline-none text-cebai-base-dark text-base py-2 appearance-none transition-all w-full max-w-64 sm:w-40 sm:focus:w-64 focus:outline-none focus:border-cebai-primary", {
          'border-cebai-grey-light': _ctx.hasSearchText,
          'border-transparent': !_ctx.hasSearchText,
        }]),
              disabled: !_ctx.hasChallenges && !_ctx.hasSearchText
            }, null, 10, _hoisted_3), [
              [_vModelText, _ctx.searchText]
            ]),
            (_ctx.searchText)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "hover:cursor-pointer px-0 absolute right-0 top-1/2 -translate-y-1/2",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetSearchText && _ctx.resetSearchText(...args)))
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_CloseIcon, { class: "w-3 h-3 text-cebai-grey-dark fill-current" })
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_ChallengesListDropdownFilter, {
            "filter-tag-options": _ctx.filterTagOptions,
            "selected-filter-tag-options": _ctx.selectedFilterTagOptions,
            "filter-topic-options": _ctx.filterTopicOptions,
            "selected-filter-topic-options": _ctx.selectedFilterTopicOptions,
            "filter-subject-options": _ctx.filterSubjectOptions,
            "selected-filter-subject-options": _ctx.selectedFilterSubjectOptions,
            "toggle-clear-filter": _ctx.clearFilter,
            "is-disabled": !_ctx.hasChallenges
          }, null, 8, ["filter-tag-options", "selected-filter-tag-options", "filter-topic-options", "selected-filter-topic-options", "filter-subject-options", "selected-filter-subject-options", "toggle-clear-filter", "is-disabled"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_LoadingIcon, { class: "text-cebai-primary" })
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (_ctx.hasChallenges)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.challenges, (challenge) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: challenge._id,
                    class: "w-full sm:w-1/2 lg:w-1/3 p-3"
                  }, [
                    _createVNode(_component_ChallegesListItem, { challenge: challenge }, null, 8, ["challenge"])
                  ]))
                }), 128))
              ]))
            : (!_ctx.hasChallenges && _ctx.hasSearchText)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
              : (!_ctx.hasChallenges && _ctx.isResolved)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                : (!_ctx.hasChallenges && !_ctx.isResolved)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      class: _normalizeClass({
          'my-6 px-5 py-6 rounded-md bg-cebai-grey-lightest text-base text-cebai-grey-dark':
            _ctx.limit,
          'my-6 px-5 py-6 text-base text-cebai-base-dark text-center': !_ctx.limit,
        })
                    }, _hoisted_16, 2))
                  : _createCommentVNode("", true)
        ], 64))
  ], 64))
}